import { render } from "./Item6.vue?vue&type=template&id=2b9799c2"
import script from "./Item6.vue?vue&type=script&lang=ts"
export * from "./Item6.vue?vue&type=script&lang=ts"
script.render = render

export default script